import 'twin.macro';
import React from 'react';
import {
  useCloseCreateFicheDePrepDrawer,
  useCloseCreateFicheDePrepInsideModalDrawer,
  useCreateFicheDePrepInsideModalPayload,
  useCreateFicheDePrepPayload,
} from 'containers/CahierJournal/CreateFicheDePrepDrawer/atoms';
import { FdpDrawer } from 'containers/CahierJournal/CreateFicheDePrepDrawer/FdpDrawer';

// En fait ici on doit être en mesure d'avoir 2 Drawer
//  Le premier est placer la modal Event, car le drawer doit être nesté dedans
// sinon on a un problème
// Et donc l'autre drawer sert lorsqu'on est sur une journée de CJ (car lors drawer n'est pas mounté
// car inside the modal...
// https://github.com/tailwindlabs/headlessui/issues/2205
export function CreateFicheDePrepDrawerInsideEventModal() {
  const payload = useCreateFicheDePrepInsideModalPayload();
  const close = useCloseCreateFicheDePrepInsideModalDrawer();
  return <FdpDrawer isOpen={!!payload} seance={payload} onClose={close} />;
}

export function CreateFicheDePrepDrawer() {
  const payload = useCreateFicheDePrepPayload();
  const close = useCloseCreateFicheDePrepDrawer();
  return <FdpDrawer isOpen={!!payload} seance={payload} onClose={close} />;
}
